import React from 'react'
import { WContainer } from 'react-components/atoms'
import RicercaAgente from 'react-components/organisms/RicercaAgente/RicercaAgente'

const TrovaAgenteTemplate = props => {
  return (
    <div className="trova-agente-template">
      <WContainer variant="inner">
        <RicercaAgente />
      </WContainer>
    </div>
  )
}

export default TrovaAgenteTemplate
